export const NAME = 'edit-table';

export const EDIT_TABLE_FILTER_ALL = 'all';
export const EDIT_TABLE_FILTER_SOME = 'some';
export const EDIT_TABLE_FILTER_HEADINGS = 'headings';
export const EDIT_TABLE_FILTER_REFERENCES = 'references';
export const EDIT_TABLE_FILTER_ANNOTATIONS = 'annotations';
